

const ReceiptsSvg = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2656 0H3.75519C1.50208 0 0 1.12656 0 3.75519V9.01245C0 11.6411 1.50208 12.7676 3.75519 12.7676H11.2656C13.5187 12.7676 15.0208 11.6411 15.0208 9.01245V3.75519C15.0208 1.12656 13.5187 0 11.2656 0ZM3.19191 8.26141C3.19191 8.56934 2.93656 8.82469 2.62863 8.82469C2.32071 8.82469 2.06535 8.56934 2.06535 8.26141V4.50623C2.06535 4.1983 2.32071 3.94295 2.62863 3.94295C2.93656 3.94295 3.19191 4.1983 3.19191 4.50623V8.26141ZM7.51038 8.63693C6.26365 8.63693 5.25726 7.63054 5.25726 6.38382C5.25726 5.1371 6.26365 4.13071 7.51038 4.13071C8.7571 4.13071 9.76349 5.1371 9.76349 6.38382C9.76349 7.63054 8.7571 8.63693 7.51038 8.63693ZM12.9554 8.26141C12.9554 8.56934 12.7 8.82469 12.3921 8.82469C12.0842 8.82469 11.8288 8.56934 11.8288 8.26141V4.50623C11.8288 4.1983 12.0842 3.94295 12.3921 3.94295C12.7 3.94295 12.9554 4.1983 12.9554 4.50623V8.26141Z"
        fill="#2D3748"
      />
    </svg>
  );
};

export default ReceiptsSvg;


